export default __webpack_public_path__ + "static/step-apply-0686459c813842dfedfcaa66105f4649.png";